import { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

SendMessageButton.propTypes = {
    sendNewMessage: PropTypes.func.isRequired,
};

export default function SendMessageButton({ sendNewMessage }) {
    const sendButton = useRef();
    const isEmptyInput = useSelector(state => state.messages.isEmptyInput);
    const messageLimit = useSelector(state => state.messages.messageLimit);
    const loadingReply = useSelector(state => state.messages.loadingReply);

    // Disable send button if empty input or reached character limit
    useEffect(() => {
        sendButton.current.disabled = Boolean(messageLimit || isEmptyInput || loadingReply);
    }, [messageLimit, isEmptyInput, loadingReply]);

    return (
        <button ref={ sendButton } id="sendMessage" onClick={ sendNewMessage }>
            <i className="fa fa-arrow-right fa-lg" aria-hidden="true"></i>
        </button>
    );
};
